import axios from 'axios';
import { getAuthToken } from '@/services/authSession';

export default class WService {
  getMethod(url) {
    const keyT = getAuthToken();
    const bearer = 'Bearer ' + keyT;
    var config = {
        method: 'get',
        url: url,
        headers: { 'Authorization': bearer }
    };
          
    const promise = axios(config);
    return promise.then((response) => {
        return response.data;
    })
  }

  getMethodWithParam(url, params) {
    const keyT = getAuthToken();
    const bearer = 'Bearer ' + keyT;
    var config = {
      method: 'get',
      url: url,
      params: params,
      headers: { 'Authorization': bearer }
    };

    const promise = axios(config);
    return promise.then((response) => {
      return response.data;
    })
  }

  postMethod(url, data, id = "") {
    const keyT = getAuthToken();
    const bearer = 'Bearer ' + keyT;
    var config = {
        method: id !== "" ? 'put' : 'post',
        url: url,
        headers: { 
            'Authorization': bearer,
            'Content-Type': 'application/json'
          },
        data : data
    };
    const promise = axios(config);
    return promise.then((response) => {
        return response.data;
    })
  }

  putMethod(url, data) {
    const keyT = getAuthToken();
    const bearer = 'Bearer ' + keyT;
    var config = {
        method: 'put',
        url: url,
        headers: { 
            'Authorization': bearer,
            'Content-Type': 'application/json'
          },
        data : data
    };
    const promise = axios(config);
    return promise.then((response) => {
        return response.data;
    })
  }

  pdfMethod(url) {
    const keyT = getAuthToken();
    const bearer = 'Bearer ' + keyT;
    var config = {
      method: 'get',
      url: url,
      responseType: 'arraybuffer',
      headers: { 'Authorization': bearer }
    };

    const promise = axios(config);
    return promise.then((response) => {
      return (response);
    })
  }

  deleteMethod(url, id) {
    const keyT = getAuthToken();
    const bearer = 'Bearer ' + keyT;
    var config = {
        method: 'delete',
        url: url + id,
        headers: { 'Authorization': bearer }
    };
    const promise = axios(config);
    return promise.then((response) => {
        return response.data;
    })
  }
}
